<template>
  <div class="fh">
  <div class="chengji">
    <div class="chengji_biaoti">{{userinfo ? userinfo.paperNr : ""}}</div>
    <div class="chengji_user">{{loginUser}}&nbsp;&nbsp;{{realUser}}</div>
  </div>
  <div class="chengji_neirong">
    <div class="chengji_neirong_one">
      <div class="chengji_neirong_one_chengji">
        考试成绩：<span class="chengji_neirong_one_chengji_biaoti">{{userinfo ? userinfo.User_Paper_ZF : ""}}</span><span>&nbsp;分</span>
      </div>
      <div class="chengji_neirong_one_shijian">
        考试用时：<span class="chengji_neirong_one_shijian_biaoti">{{userinfo ? userinfo.User_Paper_yongshi: ""}}</span><span>&nbsp;分钟</span>
      </div>
    </div>

    <div class="chengji_neirong_two">
      <div class="chengji_neirong_two_chengji">
        &nbsp;&nbsp;&nbsp;正确率：<span class="chengji_neirong_two_chengji_biaoti">{{zql}}</span>%
      </div>
      <div class="chengji_neirong_two_shijian">
        &nbsp;&nbsp;&nbsp;错题数：<span class="chengji_neirong_two_shijian_biaoti">{{userinfo ? userinfo.wrongCount : ""}}</span>
      </div>
    </div>
    <div class="fanhui">
      <button class="fanhui_lianjie" v-on:click="fanhui">返回试卷列表</button>
    </div>
    <div v-if="isShow"  class="neirong_error">
      <div class="neirong_error_list" v-for="(item, index) of userErrorAnswers" :key="item.question.qId">
        <div class="neirong_error_list_title">
          <div class="neirong_error_list_num">{{index + 1}}.{{item.question.qType}}</div>
          &nbsp;&nbsp;&nbsp;&nbsp;<span class="neirong_error_list_name">{{item.question.qName}}</span>
          <span class="neirong_error_list_brage">回答错误，用户答案见下：</span>
        </div>
        <div class="neirong_error_list_option">
          <ul>
            <li v-for="option of item.errAnswer" :key="option.value">{{option.label}}</li>
          </ul>
        </div>
        <div>
          <div class="neirong_error_list_asy">答案解析</div>
          <div class="neirong_error_list_asy_neirong">&nbsp;&nbsp;&nbsp;{{item.question.Questions_BZ}}</div>
        </div>

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      userinfo: null,
      userErrorAnswers: [],
      show: false,
      zql: 0,
      user: null
    }
  },
  computed: {
    isShow () {
      let flag = false
      flag = this.userErrorAnswers.length > 0
      return flag
    },
    loginUser () {
      return this.user ? this.user.userDl :' '
    },
    realUser () {
      return this.user ? this.user.userMc : ' '
    }
  },
  mounted: function () {
    if (!this.$store.state.loginUser) {
      this.$router.replace('/')
      return
    }
    this.userErrorAnswers = this.$store.state.userErrorAnswers
    this.userinfo = this.$store.state.userInfo
    this.user = this.$store.state.loginUser
    if (this.userinfo) {
      console.log()
      if (this.userinfo.wrongCount === this.userinfo.questionsCount) {
        this.zql = 0
      } else if (this.userinfo.wrongCount <= 0) {
        this.zql = 100
      } else {
        this.zql = Math.round((this.userinfo.questionsCount - this.userinfo.wrongCount) / this.userinfo.questionsCount * 100)
      }
    }
  },
  methods: {
    fanhui: function () {
      this.$store.commit('paperIdChange', {})
      this.$store.commit('userInfoChange', {})
      this.$router.replace('/list')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .fh
    width: 100%
    .chengji
      padding: .3rem
      padding-bottom : .1rem
      background: #00bcd4
      border-bottom: 1px solid #ccc
      .chengji_biaoti
        color: #fff
        font-size: .5rem
        line-height: .6rem
      .chengji_user
        padding-top : 10px
        color: #e8e8e8
        text-align: right
    .chengji_neirong
      padding: .2rem .2rem 0 .2rem
      font-size: .35rem
      text-align: center
      .chengji_neirong_one
        padding-top: .2rem
        padding-bottom: .2rem
        border-bottom: 1px solid #d7d7d7
        display: flex
        .chengji_neirong_one_chengji
          width: 50%
        .chengji_neirong_one_chengji_biaoti
          font-weight: bold
        .chengji_neirong_one_shijian
          width: 50%
        .chengji_neirong_one_shijian_biaoti
          font-weight: bold
      .chengji_neirong_two
        margin-top: .2rem
        padding-top: .2rem
        padding-bottom: .2rem
        border-bottom: 1px solid #d7d7d7
        display: flex
        .chengji_neirong_two_chengji
          width: 50%
          .chengji_neirong_two_chengji_biaoti
            font-weight: bold
          .chengji_neirong_two_shijian
            width: 50%
          .chengji_neirong_two_shijian_biaoti
            font-weight: bold
      .fanhui
        text-align: left
        margin-top: .2rem
        margin-left: .5rem
        .fanhui_lianjie
          background: #AC2925
          border-radius: .1rem
          text-align: center
          width: 90%
          color: white
          padding: .1rem
      .neirong_error
        margin-top: .5rem
        text-align: justify
        font-size: .3rem
        overflow-y: scroll
        .neirong_error_list
          border-bottom: 1px solid #d7d7d7
          padding-top: .1rem
          padding-bottom: .1rem
          .neirong_error_list_title
            padding-bottom: 10px
            .neirong_error_list_num
              padding-bottom: 5px
            .neirong_error_list_brage
              color: #AC2925
          .neirong_error_list_option
            padding-bottom: 5px
            padding-left: 25px
          .neirong_error_list_asy
            color: #976E48
            padding-bottom: 5px
            padding-top: 5px
          .neirong_error_list_asy_neirong
            padding: 5px
            text-align: justify
</style>



// WEBPACK FOOTER //
// src/question/fh.vue